// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

import { Separator } from '../../../atoms';

import { Instructions } from './instructions';
import { Ticket } from './ticket';

export function CashfreeUpiQrcodePage(): Node {
  return (
    <Root>
      <Body>
        <Title>QR Code Generated!</Title>
        <Subtitle>
          It won&#39;t be long until your order is complete! Use the following information to complete the payment:
        </Subtitle>
        <Separator direction="vertical" size={4} />
        <Ticket />
        <Separator direction="vertical" size={4} />
        <Instructions />
      </Body>
    </Root>
  );
}

const Root = styled.div`
  color: ${props => props.theme.colors.gray(20)};
`;

const Body = styled.div`
  padding: 32px 0;
`;

const Title = styled.h1`
  font-size: 22px;
  font-weight: 700;
  line-height: 27px;
  margin-bottom: 7px;
  font-family: Gilroy, "Open Sans", "OpenSans", Arial, "Helvetica Neue", Helvetica, sans-serif;
`;

const Subtitle = styled.p`
  margin-bottom: 24px;
`;
